define.alias("ember-power-select/components/power-select/options", "calendar/components/power-select/options");